import { useState, useEffect } from 'react';
import axios, { endpoints } from 'src/utils/axios';
import { ProductType } from 'src/type/product';
import { Pagination } from 'src/type/utils';
import { fParams, ParamsType } from 'src/utils/format-params';
import { omit } from 'lodash';
import { useBoolean } from './use-boolean';

export default function useProductOptions(clean: boolean = false, userId?: string) {
  const loading = useBoolean(true);
  const [options, setOptions] = useState<{ label: string; value: string; info: ProductType }[]>([]);

  useEffect(() => {
    (async () => {
      try {
        let products = Array<ProductType>();
        const firstChunk = await getProducts();

        if (!firstChunk.results.length) {
          throw new Error('No products found');
        }

        products = [...firstChunk.results];
        const paginateInfo = omit(firstChunk, 'results');

        for (let i = 1; i <= paginateInfo.totalPages; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          const chunk = await getProducts({ lastDocId: products[products.length - 1].id });
          products = [...products, ...chunk.results];
        }

        const opt = products?.map((product) => ({
          label: product.name,
          value: product.id,
          info: product,
        }));

        if (!clean) {
          opt.unshift({ label: 'ทุกประเภท', value: 'all', info: {} as ProductType });
        }

        setOptions(opt);
      } catch (error) {
        setOptions([]);
      } finally {
        loading.onFalse();
      }
    })();
  }, []);

  const getProducts = async (params?: ParamsType) => {
    const _params = {
      limit: 30,
      ...(userId && { userId }),
      ...params,
    };

    const { data } = await axios.get<Pagination<ProductType>>(
      userId ? endpoints.product.getAllForUser : endpoints.product.get,
      {
        params: fParams(_params),
      }
    );
    return data;
  };

  return { productOptions: options, isProductOptionsLoading: loading.value };
}
